module.exports = __webpack_public_path__ + "static/img/baby_2.a4c5fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baby_2.png
// module id = UeZg
// module chunks = 1